Vue.component('makeAppointment2', {
    data() {
        return {
            root: this.$root,
            currentQuestion: 1,
            showOverview: false,
            checklistQuestions: checklistQuestionsGlobal,
        };
    },
    mounted() {

        // Set 'givenAnwser' property for each question
        this.checklistQuestions.forEach((question) => {
            Vue.set(question, 'givenAnswer', null);
            Vue.set(question, 'givenAnswerMulti', []);
        });

    },
    computed: {
        activeQuestion() {
            return this.checklistQuestions[this.currentQuestion - 1];
        },

        checklistQuestionsString() {
            var s = "";
            this.checklistQuestions.forEach((question) => {
                if (question.givenAnswerMulti && question.givenAnswerMulti.length > 0) {
                    s += question.givenAnswerMulti.join('#') + ",";
                } else {
                    s += question.givenAnswer + ",";
                }
            });

            return s;
        }
    },
    watch: {
    },
    methods: {

        prevQuestion(event) {

            if (event) {
                event.preventDefault();
            }

            if (this.showOverview) {
                this.showOverview = false;
            } else {
                this.currentQuestion -= 1;
            }

        },
        nextQuestion(event) {

            if (event) {
                event.preventDefault();
            }

            if (this.currentQuestion <= this.checklistQuestions.length) {
                this.currentQuestion += 1;
            }
            this.showOverview = false;
        },
        showOverviewButton(event) {

            if (event) {
                event.preventDefault();
            }

            this.showOverview = true;

        },
        expandCollapse(event) {
            /*
            var el = document.getElementById('questionlistquestions');
            console.log(el.clientHeight);
            if (el.clientHeight > 0) {
                el.style.height = 0;
            }*/

            if (event) {
                event.preventDefault();
            }

        },
        gotoQuestion(question, index) {
            if (question.givenAnswer || index < this.currentQuestion) {
                this.currentQuestion = index + 1;
            }

            this.showOverview = false;
        },
        answerString(question) {

            if (question.givenAnswer) {
                return question.options.filter(t => t.id === question.givenAnswer)[0].title;
            }
            else if (question.givenAnswerMulti && question.givenAnswerMulti.length > 0) {

                var s = "";
                question.givenAnswerMulti.forEach((q) => {
                    s += question.options.filter(t => t.id === q)[0].title + ", ";
                });

                return s.replace(/,\s+$/, "");

            }

            return "-";
        }

    },
});